import { useMutation } from '@tanstack/react-query'
import { updateSpendLimit } from 'api/payment'
import { useAuthContext } from 'components/auth'

interface UseUpdateSpendLimitMutation {
  onSuccess?: () => void
  onError?: (err: Error) => void
}

export function useUpdateSpendLimitMutation(
  options?: UseUpdateSpendLimitMutation
) {
  const { company } = useAuthContext()

  return useMutation({
    mutationFn: async (limit: number) => {
      if (!company?.id) {
        throw new Error('Company id not found')
      }
      return updateSpendLimit(company.id, limit)
    },
    ...options,
  })
}
